module.exports = __webpack_public_path__ + "img/heart2heart-poster4.6344e051.jpg";